import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { queryClient } from "shared/util/queryClient";
import { VincularDespesaGroupPayRequest } from "types/request/groupPay/VincularDespesaGroupPayRequest";

export const usePostVincularDespesaGroupPay = () => {
  const onSuccess = () => {
    queryClient.invalidateQueries(["despesas-paginadas-group-pay"]);
    queryClient.invalidateQueries(["registro-contas-pagar-tabela-group-pay"]);
    toast.success("Despesa vinculada com sucesso!");
  };

  return usePost<VincularDespesaGroupPayRequest>({
    url: api.groupPay.postVincularDespesa,
    onSuccess,
  });
};
